export default __webpack_public_path__ + "images/f4260269d41341790739a3da03ecc0d5.png";